import { Image } from '../../components/ImageGrid/components/Image.js';
import { ImageButton } from '../../components/ImageGrid/components/ImageButton.js';
import { ImageFallback } from '../../components/ImageGrid/components/ImageFallback.js';
import { Item } from '../../components/ImageGrid/components/Item.js';
import { Root } from '../../components/ImageGrid/components/Root.js';
export const ImageGrid = {
  Image,
  ImageButton,
  ImageFallback,
  Item,
  Root
};